import React from "react";
import PropTypes from "prop-types";
import styles from "./fielsError.module.scss";

const FieldError = ({ text }) => {
  return (
    <div className={styles.fieldError}>
      <div className={styles.message} role="alert">
        {text}
      </div>
    </div>
  );
};

FieldError.propTypes = {
  text: PropTypes.string,
};

FieldError.defaultProps = {
  text: "",
};

export default FieldError;
